// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__2qNbd","item":"styles_item__mDDsv","imgHolder":"styles_imgHolder__3UVqV","quantity":"styles_quantity__ahx3C","price":"styles_price__K0ccd"};